import { render } from "./langSelector.vue?vue&type=template&id=4170690f"
import script from "./langSelector.vue?vue&type=script&lang=js"
export * from "./langSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__